import styled from 'styled-components'

export const Container = styled.div`
  #mui-component-select-type {
    padding: 18.5px 24px 10.5px;
  }
`
